import { EMPTY_LIST, EMPTY_STRING } from '../../../constants/common'
import { ROLE_TRANSLATION_ALIASES } from '../../../constants/user'
import { getPhoneDisplayValue } from '../../Phone'
import {
  isProfileUserCardPhoneContactType,
  PROFILE_USER_CARD_CONTACT_TYPE,
} from '../ProfileUserInfoItemCard'

import {
  PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY,
  PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE,
} from './ProfileUserInfoItem.constants'

function getUserInfoTooltipContactConfig(contactType) {
  switch (contactType) {
    case PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE.authEmail:
      return {
        labelKey: PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY.mainEmail,
        type: PROFILE_USER_CARD_CONTACT_TYPE.email,
      }
    case PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE.authPhone:
      return {
        labelKey: PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY.mainTelephone,
        type: PROFILE_USER_CARD_CONTACT_TYPE.phone,
      }
    case PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE.email:
      return {
        labelKey: PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY.additionalEmail,
        type: PROFILE_USER_CARD_CONTACT_TYPE.email,
      }
    case PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE.phone:
      return {
        labelKey: PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY.additionalTelephone,
        type: PROFILE_USER_CARD_CONTACT_TYPE.phone,
      }
    case PROFILE_USER_INFO_ITEM_TOOLTIP_CONTACT_TYPE.website:
      return {
        labelKey: PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY.website,
        type: PROFILE_USER_CARD_CONTACT_TYPE.website,
      }
    default:
      return undefined
  }
}

function getUserInfoTooltipContactValue(config, value) {
  return isProfileUserCardPhoneContactType(config.type)
    ? getPhoneDisplayValue(value)
    : value
}

function getContactsFromUserInfoTooltip(userInfoTooltip, t) {
  const contacts = []

  for (const contact of userInfoTooltip.contacts || EMPTY_LIST) {
    const config = getUserInfoTooltipContactConfig(contact.contact_type)

    if (config && contact.value) {
      contacts.push({
        label: t(config.labelKey),
        type: config.type,
        value: getUserInfoTooltipContactValue(config, contact.value),
      })
    }
  }

  if (userInfoTooltip.personal_status?.value) {
    contacts.push({
      label: t(PROFILE_USER_INFO_ITEM_CONTACT_LABEL_KEY.personalStatus),
      type: PROFILE_USER_CARD_CONTACT_TYPE.info,
      value: userInfoTooltip.personal_status.value,
    })
  }

  return contacts
}

function getCardDataFromUserInfoTooltip(userInfoTooltip, t) {
  const roleTranslationKey = ROLE_TRANSLATION_ALIASES[userInfoTooltip.role]

  return {
    ...userInfoTooltip,
    avatarColor: userInfoTooltip.avatar_color,
    contacts: getContactsFromUserInfoTooltip(userInfoTooltip, t),
    isArchived: userInfoTooltip.archived,
    role: roleTranslationKey ? t(roleTranslationKey) : EMPTY_STRING,
  }
}

export function getProfileUserCardDataFromUserInfoTooltip(userInfoTooltip, t) {
  return userInfoTooltip
    ? getCardDataFromUserInfoTooltip(userInfoTooltip, t)
    : null
}
